const aiModule = require('@repo/ai/ai-configs');
const AI_CONFIG_DEFINITIONS = aiModule?.AI_CONFIG_DEFINITIONS || aiModule?.default?.AI_CONFIG_DEFINITIONS || [];
const AI_CONFIG_PROVIDERS = aiModule?.AI_CONFIG_PROVIDERS || aiModule?.default?.AI_CONFIG_PROVIDERS || [];

const permissions = [
    {
        id: 'bo-user',
        label: 'Utilisateurs backoffice',
        permissions: [
            { id: 'bo-user:create', label: 'create' },
            { id: 'bo-user:read', label: 'see' },
            {
                id: 'bo-user:update',
                label: 'update',
                link: ['bo-user:update:password'],
            },
            {
                id: 'bo-user:update:password',
                label: 'reset-password',
            },
            { id: 'bo-user:remove', label: 'delete' },
        ],
    },
    {
        id: 'bo-role',
        label: 'Rôles utilisateurs backoffice',
        permissions: [
            { id: 'bo-role:create', label: 'create' },
            { id: 'bo-role:read', label: 'see' },
            { id: 'bo-role:update', label: 'update' },
            { id: 'bo-role:remove', label: 'delete' },
        ],
    },
    {
        id: 'user',
        label: 'Utilisateur web',
        permissions: [
            {
                id: 'user:create',
                label: 'create',
                link: ['user:create:user', 'user:create:superadmin'],
            },
            { id: 'user:create:user', label: 'create-a-simple-user' },
            {
                id: 'user:create:superadmin',
                label: 'create-super-admin-user',
            },
            { id: 'user:read', label: 'see' },
            { id: 'user:update', label: 'update' },
            { id: 'user:remove', label: 'delete' },
        ],
    },
    {
        id: 'role',
        label: 'Rôle utilisateur web',
        permissions: [
            { id: 'role:create', label: 'create' },
            { id: 'role:read', label: 'see' },
            { id: 'role:update', label: 'update' },
            { id: 'role:remove', label: 'delete' },
        ],
    },
    {
        id: 'company',
        label: 'Société',
        permissions: [
            { id: 'company:create', label: 'create' },
            { id: 'company:read', label: 'see' },
            { id: 'company:update', label: 'update' },
            { id: 'company:remove', label: 'delete' },
        ],
    },
    {
        id: 'contact',
        label: 'Contact',
        permissions: [
            { id: 'contact:create', label: 'create' },
            { id: 'contact:read', label: 'see' },
            { id: 'contact:update', label: 'update' },
            { id: 'contact:remove', label: 'delete' },
        ],
    },
    {
        id: 'plan',
        label: 'Plan',
        permissions: [
            { id: 'plan:create', label: 'create' },
            { id: 'plan:read', label: 'see' },
            { id: 'plan:update', label: 'update' },
            { id: 'plan:remove', label: 'delete' },
        ],
    },
    {
        id: 'quota',
        label: 'Quota',
        permissions: [
            { id: 'quota:create', label: 'create' },
            { id: 'quota:read', label: 'see' },
            { id: 'quota:update', label: 'update' },
            { id: 'quota:remove', label: 'delete' },
        ],
    },
    {
        id: 'license',
        label: 'Licence',
        permissions: [
            { id: 'license:create', label: 'create' },
            { id: 'license:read', label: 'see' },
            { id: 'license:update', label: 'update' },
            { id: 'license:remove', label: 'delete' },
        ],
    },
    {
        id: 'stat',
        label: 'Statistiques',
        permissions: [{ id: 'stat:stats', label: 'Statistiques' }],
    },
    {
        id: 'ai-config',
        label: 'Configs IA',
        permissions: [
            { id: 'ai-config:create', label: 'create' },
            { id: 'ai-config:read', label: 'see' },
            { id: 'ai-config:update', label: 'update' },
            { id: 'ai-config:remove', label: 'delete' },
            { id: 'ai-config:version-read', label: 'read versions' },
            { id: 'ai-config:version-write', label: 'write versions' },
            { id: 'ai-config:deploy', label: 'deploy' },
            { id: 'ai-config:rollback', label: 'rollback' },
        ],
    },
    {
        id: 'waiting-sentence',
        label: "Phrases d'attente IA",
        permissions: [
            { id: 'waiting-sentence:create', label: 'create' },
            { id: 'waiting-sentence:read', label: 'see' },
            { id: 'waiting-sentence:update', label: 'update' },
            { id: 'waiting-sentence:remove', label: 'delete' },
        ],
    },
    {
        id: 'setting',
        label: 'Configuration backoffice',
        permissions: [
            { id: 'setting:create', label: 'create' },
            { id: 'setting:read', label: 'see' },
            { id: 'setting:update', label: 'update' },
        ],
    },
    {
        id: 'announcement',
        label: 'Annonces',
        permissions: [
            { id: 'announcement:create', label: 'create' },
            { id: 'announcement:read', label: 'see' },
            { id: 'announcement:update', label: 'update' },
            { id: 'announcement:remove', label: 'delete' },
        ],
    },
    {
        id: 'tip',
        label: 'Tips',
        permissions: [
            { id: 'tip:create', label: 'create' },
            { id: 'tip:read', label: 'see' },
            { id: 'tip:update', label: 'update' },
            { id: 'tip:remove', label: 'delete' },
        ],
    },
    {
        id: 'neylia-referential',
        label: 'Référentiels fonctionnels',
        permissions: [
            { id: 'neylia-referential:create', label: 'create' },
            { id: 'neylia-referential:read', label: 'see' },
            { id: 'neylia-referential:update', label: 'update' },
            { id: 'neylia-referential:remove', label: 'delete' },
        ],
    },
    {
        id: 'cron',
        label: 'Crons',
        permissions: [
            { id: 'cron:create', label: 'create' },
            { id: 'cron:read', label: 'see' },
            { id: 'cron:update', label: 'update' },
            { id: 'cron:remove', label: 'delete' },
        ],
    },
    {
        id: 'credit',
        label: 'Crédits',
        permissions: [
            { id: 'credit:create', label: 'create' },
            { id: 'credit:read', label: 'see' },
            { id: 'credit:update', label: 'update' },
            { id: 'credit:remove', label: 'delete' },
        ],
    },
    {
        id: 'users-group',
        label: 'Groupes d\'utilisateurs',
        permissions: [
            { id: 'users-group:create', label: 'create' },
            { id: 'users-group:read', label: 'see' },
            { id: 'users-group:update', label: 'update' },
            { id: 'users-group:remove', label: 'delete' },
        ],
    },
    {
        id: 'profile-matching',
        label: 'Profile Matching',
        permissions: [
            { id: 'profile-matching:create', label: 'create' },
            { id: 'profile-matching:read', label: 'see' },
            { id: 'profile-matching:remove', label: 'delete' },
        ],
    },
    {
        id: 'outbound',
        label: 'Prise de contact',
        permissions: [
            { id: 'outbound:companies', label: 'access-companies' },
            { id: 'outbound:contacts', label: 'access-contacts' },
            { id: 'outbound:candidates', label: 'access-candidates' },
        ],
    },
    {
        id: 'mailing:contact-list',
        label: 'Mailing - Listes de contacts',
        permissions: [
            { id: 'mailing:contact-list:create', label: 'create' },
            { id: 'mailing:contact-list:read', label: 'see' },
            { id: 'mailing:contact-list:update', label: 'update' },
            { id: 'mailing:contact-list:delete', label: 'delete' },
        ],
    }
];

const languages = [
    { value: 'fr', label: 'french' },
    { value: 'en', label: 'english' },
    { value: 'es', label: 'spanish' },
];

/**
 * Catalogue fonctionnel des modules exposés par l'application.
 *
 * `value` correspond à la clé historique utilisée par l'admin et certains écrans métiers.
 * `moduleKey` est la clé canonique de routage et de HAL/Hateoas.
 * On l'ajoute pour éviter de déduire les chemins depuis `value`, car `value` n'est pas
 * garanti de correspondre à l'identité globale du module jusqu'à l'URL front.
 */
const modules = [
    { value: 'dt', moduleKey: 'dts', label: 'dt-creation' },
    { value: 'opportunity', moduleKey: 'opportunities', label: 'job-sheet' },
    { value: 'interviewPreparation', moduleKey: 'interview-preparations', label: 'interview-preparation' },
    { value: 'profile-matching', moduleKey: 'profile-matchings', label: 'profile-matching' },
    { value: 'outbound', moduleKey: 'outbound', label: 'outbound' },
    { value: 'marketing-calendars', moduleKey: 'marketing-calendars', label: 'marketing' },
];

const planStates = [
    { value: '0', label: 'invisible', color: '#ff8000' },
    { value: '1', label: 'visible', color: 'green' },
    { value: '2', label: 'inactive', color: 'gray' },
];

const planTypes = [
    { value: 'subscription', label: 'Abonnement' },
    { value: 'oneshot', label: 'Crédits' },
];

const planSubscriptionTypes = [
    { value: '1', label: 'Mensuel' },
    { value: '12', label: 'Annuel' },
];

const invoiceStates = [
    { value: '0', label: 'En attente' },
    { value: '1', label: 'Payée' },
];

const cronStates = [
    { value: 'SUCCESS', label: 'Terminé avec succès', color: 'green', criticalLevel: 0 },
    { value: 'SUCCESS_WITH_WARN', label: 'Terminé avec avertissement', color: 'orange', criticalLevel: 1 },
    { value: 'SUCCESS_WITH_ERROR', label: 'Terminé avec erreur', color: 'red', criticalLevel: 2 },
    { value: 'FAILURE', label: 'Échec', color: 'red', criticalLevel: 3 },
    { value: 'STOPPED', label: 'Arrêté', color: 'gray' },
    { value: 'RUNNING', label: 'En cours', color: 'blue' },
];

const creditExecutionsTypes = [
    { value: 'cron', label: 'Cron' },
    { value: 'client', label: 'Client' },
    { value: 'bo', label: 'Neylia' },
];

const tipsLinks = [
    // Common related errors
    {
        id: 'common',
        value: 'common',
        option: [
            { id: 'AI_TIMEOUT', value: 'ai-request-timeout', type: 'error' },
            { id: 'AI_PROMPT_TOO_LARGE', value: 'ai-request-prompt-too-large', type: 'error' },
            { id: 'AI_UNKNOWN_ERROR', value: 'ai-request-unknown-error', type: 'error' },
            { id: 'AI_ACTIVE_CONFIG_NOT_FOUND', value: 'ai-active-config-not-found', type: 'error' },
            { id: 'AI_PROMPT_NOT_FOUND', value: 'ai-prompt-not-found', type: 'error' },
            { id: 'AI_COMPLETION_FAILED', value: 'ai-completion-failed', type: 'error' },
            { id: 'AI_PARSE_FAILED', value: 'ai-parse-failed', type: 'error' },
            { id: 'AI_INVALID_REQUEST', value: 'invalid-ai-request', type: 'error' },
            { id: 'AI_REQUEST_NOT_FOUND', value: 'ai-request-not-found', type: 'error' },
            { id: 'AI_REQUEST_NO_CREDITS', value: 'ai-request-no-credits', type: 'error' },
            { id: 'NO_CREDITS', value: 'no-credits', type: 'error' },
            { id: 'USER_NO_LICENSE', value: 'user-no-license', type: 'error' },
            { id: 'NO_WEBSETTINGS', value: 'no-websettings', type: 'error' },
            { id: 'AI_PROMPT_TOO_LARGE_INCOMPLETE_WEBSETTINGS', value: 'ai-prompt-too-large-incomplete-websettings', type: 'error' },
            { id: 'FORBIDDEN', value: 'forbidden', type: 'error' },
        ],
    },
    // Boond related errors
    {
        id: 'boond',
        value: 'boond',
        option: [
            { id: 'BOOND_OPPORTUNITY_NOT_FOUND', value: 'boond-opportunity-not-found', type: 'error' },
            { id: 'BOOND_CANDIDATE_TECHNICAL_DATA_NOT_FOUND', value: 'boond-candidate-technical-data-not-found', type: 'error' },
            { id: 'BOOND_RESOURCE_TECHNICAL_DATA_NOT_FOUND', value: 'boond-resource-technical-data-not-found', type: 'error' },
            { id: 'BOOND_DICTIONARY_SETTINGS_NOT_FOUND', value: 'boond-dictionary-settings-not-found', type: 'error' },
        ],
    },
    // DT related errors
    {
        id: 'dt',
        value: 'skills-folder',
        option: [
            { id: 'DT_MODULE_DEGRADED', value: 'module-degraded', type: 'warning' },
            { id: 'DT_IMPORT_CV_REFERENCES_SOME_MISSING', value: 'dt-import-cv-references-some-missing', type: 'error' },
            { id: 'DT_IMPORT_CV_REFERENCES_SOME_ADDED', value: 'dt-import-cv-references-some-added', type: 'error' },
            { id: 'DT_IMPORT_DT_REFERENCES_DESCRIPTIONS_ALL_EMPTY', value: 'dt-import-dt-references-descriptions-all-empty', type: 'error' },
            { id: 'DT_IMPORT_DT_REFERENCES_DESCRIPTIONS_SOME_EMPTY', value: 'dt-import-dt-references-descriptions-some-empty', type: 'error' },
            { id: 'DT_IMPROVE_DT_NOT_FOUND', value: 'dt-improve-dt-not-found', type: 'error' },
            { id: 'DT_TEMPLATE_NOT_FOUND', value: 'dt-template-not-found', type: 'error' },
            { id: 'DT_BOOND_INFORMATION_COMMENTS_TOO_LONG', value: 'dt-boond-information-comments-too-long', type: 'error' },
            { id: 'DT_MISSING_REFERENCE_DT_ID', value: 'dt-missing-reference-dt-id', type: 'error' },
            { id: 'DT_SUMMARY_TARGET_ACTION_TYPE_NOT_CONFIGURED', value: 'dt-summary-target-action-type-not-configured', type: 'error' },
            { id: 'DT_STRENGTHS_TARGET_ACTION_TYPE_NOT_CONFIGURED', value: 'dt-strengths-target-action-type-not-configured', type: 'error' },
            { id: 'DT_SOFTSKILLS_TARGET_ACTION_TYPE_NOT_CONFIGURED', value: 'dt-softskills-target-action-type-not-configured', type: 'error' },
            { id: 'DT_SKILLS_TARGET_ACTION_TYPE_NOT_CONFIGURED', value: 'dt-skills-target-action-type-not-configured', type: 'error' },
            { id: 'DT_MISCELLANEOUS_TARGET_ACTION_TYPE_NOT_CONFIGURED', value: 'dt-miscellaneous-target-action-type-not-configured', type: 'error' },
            { id: 'DT_EXPORT_DT_NOT_FOUND', value: 'dt-export-dt-not-found', type: 'error' },
        ],
    },
    // Opportunity related errors
    {
        id: 'opportunity',
        value: 'job-description',
        option: [
            { id: 'OPPORTUNITY_MODULE_DEGRADED', value: 'module-degraded', type: 'warning' },
        ],
    },
    // Interview preparation related errors
    {
        id: 'interviewPreparation',
        value: 'interview-preparation',
        option: [
            { id: 'INTERVIEW_PREPARATION_MODULE_DEGRADED', value: 'module-degraded', type: 'warning' },
        ],
    },
];

const aiConfigDefinitions = AI_CONFIG_DEFINITIONS;
const aiConfigTypes = AI_CONFIG_DEFINITIONS.map(({ label, type }) => ({ value: type, label }));
const aiConfigProviders = AI_CONFIG_PROVIDERS.map(({ label, options, value }) => ({
    value,
    label,
    ...(options ? { options: { ...options } } : {}),
}));

const boondThumbnailsUrl = 'https://ui.boondmanager.com/api/thumbnails/';

export {
    permissions,
    languages,
    modules,
    planStates,
    planTypes,
    planSubscriptionTypes,
    invoiceStates,
    cronStates,
    creditExecutionsTypes,
    tipsLinks,
    aiConfigDefinitions,
    aiConfigTypes,
    aiConfigProviders,
    boondThumbnailsUrl,
};
